import Close from "@mui/icons-material/Close"
import { useContext, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { changes } from "src/components/utils/fields"
import {
  LoadingContext,
  M_Button,
  M_CheckBox,
  M_Fieldset,
  M_FormFavorites,
  M_SimpleTable,
} from "src/M_Components"
import { QuoteFormField } from "./QuoteFormField"
import { revisionCellStyle } from "../utils/quoteRevisionHelpers"
import { QuoteTablePager } from "./QuoteTablePager"
import { usePagedRows } from "../utils/usePagedRows"

const EQUIPMENT_PAGE_SIZE = 5

export const QuoteEquipment = ({ dataState, setDataState, requestMode = false }) => {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()

  const [isMultiEditable, setIsMultiEditable] = useState(!dataState.isMultiEdit)
  const fieldsEditable = !dataState.isRevisionView && isMultiEditable

  const hasEquipments = (dataState?.Equipments?.length || 0) > 0

  const formFields = [
    { display: t("Quantity"), code: "quantity", type: "number", required: requestMode && !hasEquipments },
    {
      display: t("EquipmentType"),
      required: requestMode && !hasEquipments,
      code: "equipmentType",
      type: "foreignKey",
      entity: "EquipmentType",
      filterField: "EquipmentTypeCode",
      labelFields: ["EquipmentTypeLenght", "EquipmentTypeCode"],
      fields: [
        { key: "EquipmentTypeLenght", value: "equipmentTypeLenght" },
        { key: "EquipmentTypeCode", value: "equipmentTypeCode" },
        { key: "Id", value: "equipmentTypeId" },
      ],
      favoritesFieldName: t("EquipmentType"),
      favoritesGroupName: "Equipment",
      favoritesVarKey: "equipmentType",
      favoritesIdKey: "equipmentTypeId",
    },
  ]

  const equipmentVarNameDict = useMemo(() => new Map([
    ['equipmentType', dataState.equipmentType || ''],
    ['equipmentTypeId', dataState.equipmentTypeId || ''],
  ]), [dataState.equipmentType, dataState.equipmentTypeId])

  const onChangeEquipment = (row, fields, obj) => {
    if (obj) {
      changes("equipmentTypeLenght", obj["EquipmentTypeLenght"], setDataState)
      changes("equipmentTypeCode", obj["EquipmentTypeCode"], setDataState)
      changes("equipmentTypeId", obj["Id"], setDataState)
      changes(
        "equipmentType",
        `${obj["EquipmentTypeLenght"]}${obj["EquipmentTypeCode"]}`,
        setDataState,
      )
    }
  }

  const allEquipments = (dataState["Equipments"] && dataState["Equipments"]) || []
  const equipmentPager = usePagedRows(allEquipments, EQUIPMENT_PAGE_SIZE)

  const addEquipment = () => {
    const hasType =
      dataState.equipmentTypeId ||
      dataState.equipmentType ||
      (dataState.equipmentTypeCode && dataState.equipmentTypeLenght)
    if (!hasType) {
      ctx.toastMessages('error', '', t('EquipmentType') + ' ' + t('IsRequired'))
      return
    }
    let counter = dataState?.EquipmentCounter || 1
    let newObj = {}
    let throwError = false

    if (requestMode && (!dataState?.equipmentType || Number(dataState?.quantity) < 1)) {
      ctx.toastMessages("error", t("ChargesMandatoryFieldsEmptyError"), "")
      throwError = true
    }
    if (throwError) {
      return
    }

    formFields.forEach((obj) => {
      if (
        !requestMode &&
        obj.code === "quantity" &&
        (!dataState?.[obj.code] || dataState?.[obj.code] < 1)
      ) {
        newObj[obj.code] = 1
      } else {
        newObj[obj.code] = dataState?.[obj.code] || ""
      }
      changes(obj.code, "", setDataState)
      if (obj.labelFields) {
        obj.fields.forEach((extra) => {
          newObj[extra.value] = dataState[extra.value] || ""
          changes(extra.value, "", setDataState)
        })
      }
    })

    const newEquipment = [...(dataState?.Equipments || [])]
    newObj.Id = counter
    newEquipment.push(newObj)
    changes("EquipmentCounter", counter + 1, setDataState)
    changes("Equipments", newEquipment, setDataState)
  }

  const deleteEquipment = (row) => {
    const newEquipments = dataState?.Equipments.filter(
      (equip) => equip.Id !== row.Id,
    )
    changes("Equipments", newEquipments, setDataState)
  }

  return (
    <M_FormFavorites
      entityName="Quotes"
      pageUrl="Quote"
      varNameDict={equipmentVarNameDict}
      setVarNameDict={() => {}}
      onFavoriteLoad={(loadedData) => {
        setDataState(prev => ({ ...prev, ...loadedData }))
      }}
      onAfterApply={() => {}}
    >
      <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <M_Fieldset
        height="100%"
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <i
              className="pi pi-box"
              style={{ marginRight: "10px", fontSize: "30px" }}
            ></i>{" "}
            {t("Equipment")}
            {!dataState.isRevisionView && dataState.isMultiEdit && <M_CheckBox checked={isMultiEditable} onChange={(e) => {setIsMultiEditable(e.target.checked)}} />}
          </div>
        }
        elements={
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {formFields.map((field, index) => {
                if (field.code === "equipmentType") {
                  return <QuoteFormField fields={field} index={index} data={dataState} setData={setDataState} hideLabels={null} returnFunc={onChangeEquipment} disabled={!fieldsEditable} />
                  // return fields(
                  //   field,
                  //   index,
                  //   dataState,
                  //   setDataState,
                  //   null,
                  //   onChangeEquipment,
                  // )
                }
                return <QuoteFormField fields={field} index={index} data={dataState} setData={setDataState} disabled={!fieldsEditable} />
              })}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {!dataState.isRevisionView && (
                <M_Button
                  bold
                  normal
                  hoverEffect
                  label={t("Add")}
                  icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("Add")} style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)' }} className='iconCreateBooking' />}
                  borderColor={'var(--color-grey)'}
                  onClick={() => addEquipment()}
                  disable={!fieldsEditable}
                />
                )}
              </div>
            </div>
            <div style={{ marginBottom: "20px" }}></div>
            <M_SimpleTable
              rows={equipmentPager.pagedRows}
              columns={[
                ...formFields
                  .map((obj) => {
                    return {
                      header: obj.display,
                      field: obj.code,
                      body: (row) => {
                        const rowIndex = allEquipments.findIndex(
                          (item) => item.Id === row.Id,
                        );
                        return (
                          <span
                            style={revisionCellStyle(
                              dataState,
                              "equipment",
                              rowIndex,
                              obj.code,
                            )}
                          >
                            {row[obj.code] ?? ""}
                          </span>
                        );
                      },
                    };
                  })
                  .filter(
                    (obj) => obj.type !== "whiteSpace" || obj.type !== "",
                  ),
                ...(!dataState.isRevisionView
                  ? [{
                  header: "",
                  body: (row) => (
                    <M_Button
                      none
                      icon={<Close style={{ color: "var(--color-red)" }} />}
                      onClick={() => deleteEquipment(row)}
                    />
                  ),
                }]
                  : []),
              ]}
            />
            <QuoteTablePager {...equipmentPager} />
          </div>
        }
      />
      </div>
    </M_FormFavorites>
  )
}
